export const SET_IS_START_MASS_UPLOAD = 'SET_IS_START_MASS_UPLOAD'
export const SET_IS_FAILED_MASS_UPLOAD = 'SET_IS_FAILED_MASS_UPLOAD'
